import { Currency } from '@platform-frontend/transloco';

export interface PricingInformation {
  currency: Currency;
  netValue: number;
  total: number;
  userCountryISO2Lookup: string | null;
  vatPercentage: number;
  vatReversed: boolean;
  vatValue: number;
}
